// extracted by mini-css-extract-plugin
export var deliveryRow = "_qi-a";
export var fixedHeight = "_qi-4";
export var freightLogo = "_qi-9";
export var fullWidth = "_qi-3";
export var priceColumn = "_qi-5";
export var radioSelected = "_qi-7";
export var radioUnselected = "_qi-6";
export var selectedOption = "_qi-2";
export var selectedOptionContainer = "_qi-1";
export var selection = "_qi-0";
export var tallSkeletonText = "_qi-8";